import axios from 'axios'
import baseurl from '../../apiConfig'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建一个axios实例
const service = axios.create({
  baseURL: baseurl,
  timeout: 60000
})

// 添加请求拦截器
service.interceptors.request.use(config => {
  // 在发送请求之前做某事，比如说 设置token
  // config.headers['token'] = 'token';
//   console.log(config)
  return config;
}, error => {
  // 请求错误时做些事
//   console.log(error)
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(response => {
    // console.log(response)
    const res = response.data;
    // 如果返回的状态不是200 就主动报错
    if(response.status != 200){
        return Promise.reject(res.errmsg || 'error')
    }
    return response;
}, error => {
    console.log(error)
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
})

export default service